import React from "react";
import { Carousel } from "react-responsive-carousel";
import styled from "styled-components";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 450px;
  width: 100%;
`;

// Pozn.: Původní implementace používala <div> s background-image, což
// znamenalo, že fotky nemají v DOMu žádné <img> tagy → screen-readery
// fotky neviděly a SEO obrázků nefungovalo. Předěláno na skutečný
// <img> tag s atributem alt.
const ResponsiveImage = styled.img`
  max-height: 100%;
  max-width: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
`;

const Gallery = ({ items, projectName }) => {
  return (
    <Carousel
      autoPlay={true}
      dynamicHeight={true}
      infiniteLoop={true}
      showThumbs={false} // Hide thumbnail navigation
      showStatus={false} // Hide status indicator
      showIndicators={true} // Show slide indicators
      stopOnHover={true} // Stop autoplay on hover
      interval={3000} // Set autoplay interval
      transitionTime={500} // Set transition time
      emulateTouch={true} // Enable touch events
    >
      {items.map((item, index) => (
        <div key={index}>
          <Wrapper>
            <ResponsiveImage
              src={item.src}
              alt={
                item.alt ||
                item.legend ||
                (projectName
                  ? `${projectName} – fotka ${index + 1}`
                  : `Fotka ${index + 1}`)
              }
              loading="lazy"
            />
          </Wrapper>
        </div>
      ))}
    </Carousel>
  );
};

export default Gallery;
